import { render, staticRenderFns } from "./TaskInfoList.vue?vue&type=template&id=13f7095d"
import script from "./TaskInfoList.vue?vue&type=script&lang=js"
export * from "./TaskInfoList.vue?vue&type=script&lang=js"
import style0 from "./TaskInfoList.vue?vue&type=style&index=0&id=13f7095d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports